import type { SVGProps } from 'react';

const SvgLogIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3h-7c-1.07 0-2.06.57-2.6 1.5-.28.48-.11 1.09.36 1.37.48.28 1.09.11 1.37-.37.18-.31.51-.5.87-.5h7c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-7c-.36 0-.69-.19-.87-.5a1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37.54.92 1.53 1.5 2.6 1.5h7c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3"
    />
    <path
      fill="currentcolor"
      d="M10.29 14.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41l-3-3A.996.996 0 1 0 10.3 9.7l1.29 1.29H4c-.55 0-1 .45-1 1s.45 1 1 1h7.59z"
    />
  </svg>
);
export default SvgLogIn;
